import { connectSocket } from '@/configurations/webSocket';
import { isResellerConnected } from '@/configurations/auth';

export default {
  data() {
    return {
      resellerMessage: '',
      ioConnect: false,
    };
  },
  methods: {
    getResellerMessage(client) {
      if (!client?.id || this.ioConnect) {
        return;
      }

      this.ioConnect = true;

      if (isResellerConnected()) {
        this.resellerMessage = 'Conectado como parceiro';
        this.resellerSendConnect(client);
        return;
      }

      this.checkResellerConnect(client);
    },
    async checkResellerConnect(client) {
      const socket = connectSocket();
      socket.emit('send', {
        channel: `resellerConnectedInVerification_${client.id}`,
        content: { id: socket.id },
      });

      socket.on(`resellerConnectedIn_${client.id}`, (data) => {
        this.resellerMessage = 'Parceiro conectado';
        this.listenResellerConnect(socket, data.id, client);
      });
    },
    async listenResellerConnect(socket, resellerSocketId) {
      socket.on(`disconnected_${resellerSocketId}`, () => {
        this.resellerMessage = '';
      });
    },
    async resellerSendConnect(client) {
      const socket = connectSocket();
      socket.emit('send', {
        channel: `resellerConnectedIn_${client.id}`,
        content: { id: socket.id },
      });
      socket.on(`resellerConnectedInVerification_${client.id}`, () => {
        socket.emit('send', {
          channel: `resellerConnectedIn_${client.id}`,
          content: { id: socket.id },
        });
      });
    },
  },
};
